import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import {
  ControlContainer,
  FormControl,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { fromEvent, map, of, takeUntil, tap } from 'rxjs';
import {
  MatAutocomplete,
  MatAutocompleteSelectedEvent,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { BaseFpxDataService, CriteriaQuery } from '../../models';
import { BaseFpxControlComponent } from '../../utils';
import { CompNameService } from 'src/app/foundation/compName-service/compName.service';
import { SalesIdService } from 'src/app/foundation/salesId-service/salesId.service';
import { AgentsRepoService } from 'src/app/foundation/agentsRepo-service/agentsRepo.service';

@Component({
  selector: 'sbc-searchable-dropdown',
  templateUrl: './sbc-searchable-dropdown.component.html',
  styleUrls: ['./sbc-searchable-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SbcSearchableDropdownComponent),
      multi: true,
    },
  ],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SbcSearchableDropdownComponent extends BaseFpxControlComponent {
  @Input() dropdownType: number = 1;
  public showlist = false;
  public searchInput: any;
  public isEditing: boolean = false;
  protected selectedId: string = '';
  public disable: boolean = false;
  public nextpageCall: boolean = true;
  private  _dataSource: BaseFpxDataService<unknown>;
	@Input() 
	set dataSource(val: BaseFpxDataService<unknown>){
		this._dataSource = val;
    this.setDataSource(this.getDataSource(val));
	}
	get dataSource():BaseFpxDataService<unknown>{
		return this._dataSource;
	}
  ///// autocomplete implementation

  @ViewChild('searchableDrodpown') searchableDrodpown: MatAutocomplete | any;
  @ViewChild('trigger') trigger: MatAutocompleteTrigger | any;
  previousData: Array<any> = [];
  presentData: Array<any> = [];

  constructor(
    controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef,
    private _compNameService: CompNameService,
    private _salesIdService: SalesIdService,
    private _agentsRepoService: AgentsRepoService
  ) {
    super(controlContainer, changeDetectorRef);
    this.coreControlType = 'SELECTABLEDROPDOWN';
  }
  offset: number = 1;
	pageSize: number = 50;
  protected override doPreInit(): void {
    this.setDropdownMode('SEARCHABLE');
    this.searchableDropdowninputChange.subscribe(
      (res)=>{
        let searchColumn = res.checkId?'id':'text';
        res.criteriaDetail?.addFilterCritertia(searchColumn,'String','Contains',{
                  searchText : res.value
                });
        this.selectedId = res.value == ''?'': this.selectedId
        this.offset = 1;
        res.criteriaDetail.setPaginationCriteria(
          String(this.offset),
          this.pageSize
        );
        this._dataService.lookup({}, new Map(), res.criteriaDetail)().subscribe(
          (response)=>{
            this.selectableList$ = of(response);
            // if(res.checkId && res.value != '') {
            //   this.searchableDropdowninputChange.emit({
            //     value: response[0].text,
            //     criteriaDetail: new CriteriaQuery(),
            //     checkId: false
            //   });
            // }
            this.setInitialSelectedData(response);
            this.detectChanges();
          }
        )
      }
    )
  }

  getDataSource(ds):BaseFpxDataService<unknown> {
    switch (ds) {
      case 'compName': return this._compNameService; 
      case 'salesId': return this._salesIdService;
      case 'agencyCode' : return this._agentsRepoService;
    
    }
  }
  onScroll(criteriaDetails) {
		this.offset = this.offset + this.pageSize;
		criteriaDetails.setPaginationCriteria(
			String(this.offset),
			this.pageSize
		);
    if(this.searchInput) {
      criteriaDetails?.addFilterCritertia('text','String','Contains',{
        searchText : this.searchInput.text?this.searchInput.text:this.searchInput?this.searchInput:''
      })
    }
		this._dataService.lookup({}, new Map(), criteriaDetails)().subscribe(
			(response)=>{
				this.selectableList$.subscribe(
					(res) => {
						res = [...res, ...response];
						this.selectableList$ = of(res);
						this.detectChanges();
					});
			}
		)
	}

  onSelect(event: MatAutocompleteSelectedEvent) {
    this.formControl.patchValue(event.option.value?.id,{emitEvent: true});
    // this.coreControlEvent$.next({
    //   action: 'SETVALUE',
    //   value: event.option.value?.id,
    // });
    // this.coreControlEvent$.next({
    //   action: 'ONDROPDOWNCHANGE',
    //   value: event.option.value,
    // });
    // this.commonControlEvent.emit({
    //   eventName: `${this.formControlName}_onDropdownChange`,
    //   payload: event.option.value,
    // });
  }

  onFocus() {
    this.isEditing = true;
  }
  onBlur() {
    this.isEditing = false;
    let searchText = this.searchInput.text?this.searchInput.text:this.searchInput;
      if(!searchText) {
        this.resetControl();
        return;
      }
      this.selectableList$.subscribe(
        (res) => {
          if(!res || res?.length <= 0) {
            if(this.checkOthers && this.patchFormcontrol) {
              this.searchableDropdowninputChange.emit({
                value: 'OTH',
                criteriaDetail: new CriteriaQuery(),
                checkId: true
              });
              this.formControl.patchValue('OTH');
              this.formControl.parent.get(this.patchFormcontrol).patchValue(this.searchInput, {emitEvent: true})
            }
            else {
              this.resetControl();
            }
          }
          else {
            const selectedData = res.find(
              (item: any) => item.text === searchText
            );
            if(!selectedData) {
              if(this.checkOthers && this.patchFormcontrol) {
                // this.searchableDropdowninputChange.emit({
                //   value: 'OTH',
                //   criteriaDetail: new CriteriaQuery(),
                //   checkId: true
                // });
                this.formControl.patchValue('OTH');
                this.formControl.parent.get(this.patchFormcontrol).patchValue(this.searchInput, {emitEvent: true})
              }
              else {
                this.resetControl();
              }
            }
            else this.formControl.patchValue(selectedData.id);
          }
        });
  }
  onKeyup() {
    this.nextpageCall = true;
  }

  resetControl() {
    this.formControl.reset();
    this.searchInput = '';
    this.selectedId = '';
    this.changeDetectorRef.detectChanges();
  }

  displayFn = (value: any): string => {
    return value && value.text ? value.text : '';
  };
  onChange: any = (value) => {
    if(!value) {
      this.searchInput = '';
      this.selectedId = '';
      this.changeDetectorRef.detectChanges();
      this.searchableDropdowninputChange.emit({
        value: '',
        criteriaDetail: new CriteriaQuery(),
        checkId: true
      });
    }
  }
  override setInitialSelectedData(res: any) {
    if (res && res.length > 0 && this.formControl.value && !this.isEditing) {
      const selectedData = res.find(
        (item: any) => item.id === this.formControl.value
      );
      this.searchInput = selectedData;
      this.selectedId = selectedData?.id;
      this.changeDetectorRef.detectChanges();
    }
    this.presentData = res;
    if (
      JSON.stringify(this.presentData) === JSON.stringify(this.previousData) ||
      res?.length == 0
    ) {
      this.nextpageCall = false;
    }
  }

  protected override customWriteValue(payload: any): void {
    if(payload) {
      this.searchableDropdowninputChange.emit({
        value: payload,
        criteriaDetail: new CriteriaQuery(),
        checkId: true
      });
    }
  }

  protected override customIsDisable(isDisabled: boolean): void {
    this.disable = isDisabled;
  }

  infiniteScroll() {
    setTimeout(() => {
      if (
        this.searchableDrodpown &&
        this.trigger &&
        this.searchableDrodpown.panel
      ) {
        fromEvent(this.searchableDrodpown.panel.nativeElement, 'scroll')
          .pipe(
            map((x) => {
              this.searchableDrodpown.panel.nativeElement.scrollTop;
            }),
            takeUntil(this.trigger.panelClosingActions)
          )
          .subscribe((x) => {
            this.previousData = this.presentData;
            let panelScrollTop =
              this.searchableDrodpown.panel.nativeElement.scrollTop;
            let panelClientHeight =
              this.searchableDrodpown.panel.nativeElement.scrollHeight;
            let panelElementheight =
              this.searchableDrodpown.panel.nativeElement.clientHeight;
            let maxReach = 1.0 * 100 * (panelClientHeight / 100);
            let current = panelScrollTop + panelElementheight;
            if (
              current.toFixed(2) == maxReach.toFixed(2) &&
              this.nextpageCall
            ) {
              let criteriaDetails = new CriteriaQuery();
              // let offset = Number(this.pageOptions.pageOffset);
              // this.pageOptions.pageOffset = String(offset + 10);
              // criteriaDetails.setPaginationCriteria(
              //   this.pageOptions.pageOffset,
              //   10
              // );
              this.onScroll(criteriaDetails);
            }
          });
      }
    });
  }
}
